import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from 'react-redux';
import TranslationProvider, {
  getTranslation,
} from '../../providers/TranslationProvider';
import Button from '../Button';
import ReservationButton from '../ReservationButton';
import Icon from '../Icon';
import Bell from '../../svg/icons/bell.svg';
import ALLOWED_DOMAINS from '../../constants/allowedDomains';
import openTockUrl from '../../utils/openTockUrl';
import { openTockExperienceOptions, closeTockExperienceModal } from '../../reducers/tockExperienceSlice';
import './ReservationButtonList.scss';
import CONTEXT from './constants';

class ReservationButtonList extends React.Component {
  static displayName = 'ReservationButtonList';

  static propTypes = {
    activeNotifications: PropTypes.shape({
      [PropTypes.number]: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
    Analytics: PropTypes.shape({
      event: PropTypes.func,
    }),
    ariaDescribedBy: PropTypes.string,
    className: PropTypes.string,
    clearFilterButton: PropTypes.node,
    dispatch: PropTypes.func,
    context: PropTypes.oneOf([
      CONTEXT.AFFILIATED_RESTAURANTS,
      CONTEXT.EVENT_TICKET,
      CONTEXT.HOMEPAGE,
      CONTEXT.INLINE_BOOKING,
      CONTEXT.SEARCH_RESULT,
      CONTEXT.DELTA_WIFI,
      CONTEXT.SHOP_SMALL,
      CONTEXT.AMEX_RESYCREDITELIGIBLE,
    ]),
    eventName: PropTypes.string,
    featureRecaptcha: PropTypes.bool,
    isEvent: PropTypes.bool,
    limit: PropTypes.number,
    lineLimit: PropTypes.number,
    list: PropTypes.string,
    reservations: PropTypes.arrayOf(PropTypes.object),
    serviceTypeId: PropTypes.number,
    serviceTypeName: PropTypes.string,
    onReservationSelect: PropTypes.func.isRequired,
    shouldExpand: PropTypes.bool,
    hideTableType: PropTypes.bool,
    venueId: PropTypes.number.isRequired,
    venueCity: PropTypes.string,
    venueName: PropTypes.string,
    availableServiceTypes: PropTypes.arrayOf(PropTypes.string),
    searchSessionId: PropTypes.string,
    shopSmallVenueCardEvents: PropTypes.shape({
      view_more: PropTypes.string,
      book_now: PropTypes.string,
      notify: PropTypes.string,
    }),
    shopSmallBuyoutVenueCardEvents: PropTypes.shape({
      view_more: PropTypes.string,
      book_now: PropTypes.string,
      notify: PropTypes.string,
    }),
    showNotify: PropTypes.bool,
    isAmexShopSmallBuyoutFlag: PropTypes.bool,
    isAmexShopSmallOffersFlag: PropTypes.bool,
    isTockInventory: PropTypes.bool,
    hasTockExperiences: PropTypes.bool,
    experiences: PropTypes.arrayOf(PropTypes.object),
    selectedDate: PropTypes.string,
    tockBusinessSearchUrl: PropTypes.string,
    tockNotifyUrl: PropTypes.string,
    centurionNyValue: PropTypes.bool,
    centNyTableTypesArr: PropTypes.arrayOf(PropTypes.string),
    amexVenueCardEvents: PropTypes.shape({
      view_more: PropTypes.string,
      book_now: PropTypes.string,
      notify: PropTypes.string,
      event_name: PropTypes.string,
      action_names: PropTypes.string,
    }),
    partySize: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
    closeOffering: PropTypes.func,
    isMobile: PropTypes.bool,
  };

  static defaultProps = {
    activeNotifications: {},
    Analytics: {},
    ariaDescribedBy: undefined,
    reservations: [],
    className: '',
    clearFilterButton: undefined,
    dispatch: () => {},
    context: null,
    eventName: 'this event',
    featureRecaptcha: false,
    isEvent: false,
    limit: 999,
    lineLimit: null,
    list: null,
    serviceTypeId: null,
    serviceTypeName: undefined,
    shouldExpand: false,
    hideTableType: false,
    venueCity: null,
    venueName: 'this restaurant',
    availableServiceTypes: [],
    searchSessionId: '',
    shopSmallVenueCardEvents: {},
    isAmexShopSmallOffersFlag: false,
    isAmexShopSmallBuyoutFlag: false,
    isTockInventory: false,
    hasTockExperiences: false,
    experiences: [],
    selectedDate: null,
    tockBusinessSearchUrl: undefined,
    tockNotifyUrl: undefined,
    shopSmallBuyoutVenueCardEvents: {},
    showNotify: true,
    centurionNyValue: false,
    centNyTableTypesArr: [],
    amexVenueCardEvents: {},
    partySize: 2,
    closeOffering: () => {},
    isMobile: false,
  };

  state = {
    limitSlots: true,
    limit: null,
    newNotifications: false,
  };

  componentDidMount() {
    window.addEventListener('message', this.onPostMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onPostMessage);
  }

  setListRef = (list) => {
    this.list = list;
  };

  handleNotification = (notifications) => {
    const { newNotifications } = this.state;

    if (
      Object.values(notifications).every(
        (notification) => notification === null
      )
    ) {
      if (newNotifications === true) {
        this.setState({ newNotifications: false });
        return;
      }
      return;
    }
    this.setState({ newNotifications: true });
  };

  onPostMessage = (e) => {
    const { venueId } = this.props;

    if (!ALLOWED_DOMAINS.includes(e.origin)) {
      return;
    }

    if (e.data.event === 'onNotifySync') {
      if (e.data.venueId === venueId) {
        this.handleNotification(e.data.value);
      }
    }
  };

  onSelect = ({
    e, reservation, stId, analyticsLabel, notifyService,
  }) => {
    e.stopPropagation();

    const {
      Analytics,
      closeOffering,
      context,
      dispatch,
      experiences,
      hasTockExperiences,
      list,
      onReservationSelect,
      isTockInventory,
      selectedDate,
      venueCity,
      venueId,
      venueName,
      shopSmallVenueCardEvents: {
        view_more: viewMoreEventName,
        book_now: bookNowEventName,
        notify: notifyEventName,
      },
      shopSmallBuyoutVenueCardEvents: {
        view_more: viewMoreBuyoutEventName,
        book_now: bookNowBuyoutEventName,
        notify: notifyBuyoutEventName,
      },
      isAmexShopSmallBuyoutFlag,
      isAmexShopSmallOffersFlag,
      partySize,
      searchSessionId,
      isMobile,
    } = this.props;

    const destination = isTockInventory ? 'tock' : 'resy';

    if (Analytics.event) {
      // This event will be logged for both the Discovery page and the Marketing pages (Resy Credit and Platinum Nights).
      // The Amplitude context will be used to distinguish between these pages,
      // while all other event information will remain the same.
      if (context === CONTEXT.SEARCH_RESULT || context === CONTEXT.AMEX_RESYCREDITELIGIBLE) {
        Analytics.event('click booking slot', {
          venue: venueName,
          city: venueCity,
          'is event': !!reservation?.event,
          event: reservation?.event?.title,
          'party size': partySize,
          time: reservation?.time ? moment(reservation.time).format('YYYY-MM-DD HH:mm:ss') : undefined,
          'lead time': moment(reservation?.time).diff(
            moment().startOf('day'),
            'days'
          ),
          searchSessionId,
          details: {
            city: venueCity,
            serviceType: reservation?.type,
            venueId,
          },
          destination,
        });
      } else if (context === CONTEXT.HOMEPAGE) {
        Analytics.event('click booking slot', {
          venue: venueName,
          city: venueCity,
          'is event': !!reservation?.event,
          event: reservation?.event?.title,
          'party size': partySize,
          time: reservation?.time ? moment(reservation.time).format('YYYY-MM-DD HH:mm:ss') : undefined,
          'lead time': moment(reservation?.time).diff(
            moment().startOf('day'),
            'days'
          ),
          searchSessionId,
          details: {
            city: venueCity,
            serviceType: reservation?.type,
            venueId,
          },
        });
        // MARKETING ANALYTICS START
      } else if (context === CONTEXT.SHOP_SMALL && isAmexShopSmallOffersFlag) {
        const params = {
          venue: venueName,
          venue_id: venueId,
          category: 'Shop Small Offers Interaction',
          city: venueCity,
          list,
          label: analyticsLabel,
          context: 'Shop Small Page',
        };

        if (analyticsLabel === 'dine-in brick') {
          Analytics.event(bookNowEventName, params);
        } else if (analyticsLabel === 'ellipsis') {
          Analytics.event(viewMoreEventName, params);
        } else if (analyticsLabel === 'notify') {
          Analytics.event(notifyEventName, params);
        }
      } else if (context === CONTEXT.SHOP_SMALL && isAmexShopSmallBuyoutFlag) {
        const params = {
          venue: venueName,
          venue_id: venueId,
          category: 'Shop Small Buyout Interaction',
          city: venueCity,
          list,
          label: analyticsLabel,
          context: 'Shop Small Page',
        };

        if (analyticsLabel === 'dine-in brick') {
          Analytics.event(bookNowBuyoutEventName, params);
        } else if (analyticsLabel === 'ellipsis') {
          Analytics.event(viewMoreBuyoutEventName, params);
        } else if (analyticsLabel === 'notify') {
          Analytics.event(notifyBuyoutEventName, params);
        }
      }
    }

    if (hasTockExperiences && reservation?.time) {
      if (reservation?.tockBookingUrl) {
        openTockUrl(reservation.tockBookingUrl, dispatch);
        return;
      }

      dispatch(openTockExperienceOptions({
        experiences,
        isMobile,
        selectedTime: reservation.time,
        selectedDate,
        selectedSeats: partySize,
        venueName,
        venueId,
      }));
      return;
    }

    if (isTockInventory && reservation?.tockBookingUrl) {
      closeOffering();
      openTockUrl(reservation.tockBookingUrl, dispatch);
      return;
    }

    onReservationSelect(reservation, stId, notifyService, e?.target);
  };

  expandSlots = (e) => {
    e.stopPropagation();
    this.setState({ limitSlots: false });
  };

  getExclusiveAriaLabel = (reservation) => {
    const { hideTableType } = this.props;
    const reservationTime = moment(
      reservation.time,
      'YYYY-MM-DD HH:mm:ss'
    ).format('LT');

    const labels = {
      gda: getTranslation({
        fallback: 'GDA Time Slot',
        translationKey: 'gda_time_slot',
      }),
      exclusive: getTranslation({
        fallback: 'Exclusive Time Slot',
        translationKey: 'exclusive_time_slot',
      }),
      locked: getTranslation({
        fallback: 'Locked',
        translationKey: 'locked',
      }),
    };

    if (reservation.isGda) {
      return hideTableType
        ? `${labels.gda}, ${reservationTime}`
        : `${labels.gda}, ${reservationTime} ${reservation.type}`;
    }

    if (reservation.exclusiveId !== 0) {
      return hideTableType
        ? `${labels.exclusive}, ${reservationTime}`
        : `${labels.exclusive}, ${reservationTime} (${labels.locked}) ${reservation.type}`;
    }

    return null;
  };

  renderReservation = (reservation) => {
    const {
      ariaDescribedBy,
      centNyTableTypesArr,
      centurionNyValue,
      featureRecaptcha,
      hideTableType,
    } = this.props;

    const variant = reservation.isGda ? 'rga' : undefined;
    const ariaLabel = this.getExclusiveAriaLabel(reservation);

    if (
      centurionNyValue
      && centNyTableTypesArr.length > 0
      && !centNyTableTypesArr?.includes(reservation.type)
    ) {
      return null;
    }

    return (
      <ReservationButton
        ariaDescribedBy={ariaDescribedBy}
        id={reservation.token}
        key={`${reservation.token}_${reservation.exclusiveId}`}
        onClick={(e) => this.onSelect({
          e,
          reservation: { featureRecaptcha, ...reservation },
          analyticsLabel: 'dine-in brick',
        })}
        badge={reservation.badge}
        variant={variant}
        colors={reservation.isGda ? null : reservation.colors}
        time={reservation.time}
        tableType={hideTableType ? '' : reservation.type}
        aria-label={ariaLabel}
        data-testid={`reservation-button-${reservation.token}`}
      />
    );
  };

  renderReservations = () => {
    const {
      context, limit, reservations, isAmexShopSmallBuyoutFlag,
    } = this.props;

    const { limitSlots, limit: stateLimit } = this.state;
    let calculatedLimit = stateLimit || limit;
    if (context === CONTEXT.AFFILIATED_RESTAURANTS) {
      calculatedLimit -= 1;
    }

    if (context === CONTEXT.SHOP_SMALL && isAmexShopSmallBuyoutFlag) {
      const buyoutDinnerReservations = reservations.filter(
        (o) => o.serviceTypeId === 2
      );
      const buyoutDinnerSlots = limitSlots
        ? buyoutDinnerReservations.slice(0, calculatedLimit)
        : buyoutDinnerReservations;
      return buyoutDinnerSlots.map(this.renderReservation);
    }
    const slots = limitSlots
      ? reservations.slice(0, calculatedLimit)
      : reservations;
    return slots.map(this.renderReservation);
  };

  onViewMoreClick = (e) => {
    const {
      closeOffering, dispatch, isTockInventory, shouldExpand, tockBusinessSearchUrl,
    } = this.props;

    if (isTockInventory && tockBusinessSearchUrl) {
      closeOffering();
      openTockUrl(tockBusinessSearchUrl, dispatch);
      return;
    }

    if (shouldExpand) {
      this.expandSlots(e);
      return;
    }

    this.onSelect({ e, analyticsLabel: 'ellipsis' });
  };

  renderViewMore = () => {
    const { limitSlots, limit: stateLimit } = this.state;
    const {
      ariaDescribedBy,
      context,
      eventName,
      isAmexShopSmallBuyoutFlag,
      isEvent,
      limit,
      reservations,
      venueName,
    } = this.props;

    let buttonLabel = null;

    if (context === CONTEXT.SHOP_SMALL && isAmexShopSmallBuyoutFlag) {
      const buyoutDinnerReservations = reservations.filter(
        (o) => o.serviceTypeId === 2
      );
      if (
        !limitSlots
        || buyoutDinnerReservations.length <= (stateLimit || limit)
      ) return null;
    }

    if (!limitSlots || reservations.length <= (stateLimit || limit)) return null;

    if (isEvent) {
      buttonLabel = eventName;
    } else {
      buttonLabel = venueName;
    }

    return (
      <Button
        aria-describedby={ariaDescribedBy}
        data-test-id="ReservationButtonList-button-view-more"
        aria-label={`View more availability for ${buttonLabel}`}
        type="button"
        className="ReservationButtonList__view-more"
        onClick={this.onViewMoreClick}
        variant="secondary"
      >
        <span className="separator" />
        <span className="separator" />
        <span className="separator" />
      </Button>
    );
  };

  getActiveNotifySet = () => {
    const { activeNotifications, context, serviceTypeId } = this.props;

    const { newNotifications } = this.state;

    let activeNotifySet;

    if (context === CONTEXT.INLINE_BOOKING) {
      activeNotifySet = !!activeNotifications[serviceTypeId];
    } else {
      activeNotifySet = Object.values(activeNotifications).some(
        (notifies) => notifies !== null
      );
    }

    return activeNotifySet || newNotifications;
  };

  renderNotify = () => {
    const {
      ariaDescribedBy,
      availableServiceTypes,
      closeOffering,
      context,
      dispatch,
      isAmexShopSmallBuyoutFlag,
      isTockInventory,
      limit,
      reservations,
      serviceTypeId,
      serviceTypeName,
      showNotify,
      tockNotifyUrl,
      venueName,
    } = this.props;

    if (isTockInventory && !tockNotifyUrl) return null;
    if (!isTockInventory && !showNotify) return null;

    const activeNotifySet = this.getActiveNotifySet();

    let translationKey = 'button_add_notify_venue_name';
    let fallback = `${venueName}, Notify`;

    if (activeNotifySet) {
      translationKey = 'button_remove_notify_venue_name';
      fallback = `${venueName}, Notify On`;
    }

    if (serviceTypeName) {
      if (activeNotifySet) {
        translationKey = `notify_remove_${serviceTypeName.toLowerCase()}`;
        fallback = `Notify on for ${serviceTypeName}`;
      } else {
        translationKey = `notify_${serviceTypeName.toLowerCase()}`;
        fallback = `Notify for ${serviceTypeName}`;
      }
    }

    let actualReservations = null;
    if (context === CONTEXT.SHOP_SMALL && isAmexShopSmallBuyoutFlag) {
      actualReservations = reservations.filter((o) => o.serviceTypeId === 2);
    } else {
      actualReservations = reservations;
    }

    if (
      actualReservations.length <= limit
      && (serviceTypeId || context !== CONTEXT.INLINE_BOOKING)
      && context !== CONTEXT.EVENT_TICKET
    ) {
      let notifyShiftId;

      if (availableServiceTypes[0]) {
        notifyShiftId = parseInt(availableServiceTypes[0], 10);
      }

      const notifyClassName = cx('ReservationButtonList__notify', {
        'ReservationButtonList__notify--shrink': actualReservations.length >= limit,
        'ReservationButtonList__notify--active': activeNotifySet,
      });

      if (isTockInventory && tockNotifyUrl) {
        return (
          <Button
            data-testid="ReservationButtonList__notify-button"
            aria-describedby={ariaDescribedBy}
            aria-label={getTranslation({ translationKey, translationValues: { venueName }, fallback })}
            type="button"
            className={notifyClassName}
            onClick={() => { closeOffering(); openTockUrl(tockNotifyUrl, dispatch); }}
            variant="secondary"
          >
            <Icon iconClass="bell" component={Bell} />
            <TranslationProvider translationKey="button_add_notify">
              <span className="notify-msg">Notify</span>
            </TranslationProvider>
          </Button>
        );
      }

      return (
        <Button
          data-testid="ReservationButtonList__notify-button"
          aria-describedby={ariaDescribedBy}
          aria-label={getTranslation({ translationKey, translationValues: { venueName }, fallback })}
          type="button"
          className={notifyClassName}
          onClick={(e) => this.onSelect({
            e,
            stId: serviceTypeId,
            analyticsLabel: 'notify',
            notifyService: notifyShiftId,
          })}
          variant={activeNotifySet ? 'primary' : 'secondary'}
        >
          <Icon iconClass="bell" component={Bell} />
          {activeNotifySet ? (
            <TranslationProvider translationKey="button_remove_notify">
              <span className="notify-msg">Notify On</span>
            </TranslationProvider>
          ) : (
            <TranslationProvider translationKey="button_add_notify">
              <span className="notify-msg">Notify</span>
            </TranslationProvider>
          )}
        </Button>
      );
    }

    return null;
  };

  render() {
    const { className, clearFilterButton, lineLimit } = this.props;
    const { limitSlots } = this.state;
    return (
      <div
        data-test-id="reservation-button-test-list"
        ref={this.setListRef}
        className={cx('ReservationButtonList', {
          unlimited: !limitSlots || lineLimit,
          [className]: className,
        })}
      >
        {this.renderReservations()}
        {this.renderViewMore()}
        {this.renderNotify()}
        {clearFilterButton}
      </div>
    );
  }
}

const mapStateToProps = ({ venueSearch }) => ({
  searchSessionId: venueSearch?.metadata?.searchSessionId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  closeOffering: () => dispatch(closeTockExperienceModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReservationButtonList);
